module.exports = __webpack_public_path__ + "static/media/logominedu.8ec12ff8.png";